import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_MONTHWISE_M2D_DETAIL_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";

export const getMonthWiseM2DDetailReport = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/M2DReports/GetMonthWiseM2DDetailReport`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_MONTHWISE_M2D_DETAIL_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const exportReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/M2DReports/GetMonthWiseM2DDetailReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `MonthWise_M2D_Detail_Report_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToExcel = (jsonData, fileName) => {
        if (!jsonData || jsonData.length === 0) {
          toast.error("No data available to export");
          dispatch(hideLoading());
          return;
        }

        const ws = XLSX.utils.json_to_sheet(jsonData);

        const wb = {
          Sheets: { data: ws },
          SheetNames: ["data"],
        };

        const excelBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array",
        });

        const fileData = new Blob([excelBuffer], { type: fileType });

        fileSaver.saveAs(fileData, fileName + fileExtension);
      };

      // 🔥 IMPORTANT: use data.data
      exportToExcel(data?.response.data ?? [], outputFilename);

      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message,
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
